import loadable from '@loadable/component'

export const ErrorBoundary = loadable(() => import('./ErrorBoundary'))
export default ErrorBoundary
